"use client";

import { ArrowUpRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const projects = [{
  name: "TechScale B2B",
  category: "B2B SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/techscale_b2b_growth.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/techscale_b2b_growth.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/techscale_b2b_growth.webp-wvc-sizes",
  alt: "TechScale B2B dashboard showing organic traffic growth",
  badge: "featured",
  href: "/CaseStudiesPage"
}, {
  name: "Global Retail",
  category: "Ecommerce",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/global_retail_sales.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/global_retail_sales.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/global_retail_sales.png-wvc-sizes",
  alt: "Global Retail ecommerce platform analytics report",
  badge: "",
  href: "/CaseStudiesPage"
}, {
  name: "Local Services",
  category: "Local SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/local_services_map.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/local_services_map.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/local_services_map.png-wvc-sizes",
  alt: "Local Services map pack ranking performance",
  badge: "",
  href: "/CaseStudiesPage"
}, {
  name: "FinTech SaaS",
  category: "Technical",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/fintech_saas_audit.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/fintech_saas_audit.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/fintech_saas_audit.webp-wvc-sizes",
  alt: "FinTech SaaS technical audit documentation",
  badge: "",
  href: "/CaseStudiesPage"
}, {
  name: "Health Tech",
  category: "AI Search",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/health_tech_ai.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/health_tech_ai.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/health_tech_ai.png-wvc-sizes",
  alt: "Health Tech AI search visibility insights",
  badge: "2024",
  href: "/CaseStudiesPage"
}, {
  name: "Logistics Pro",
  category: "National",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/logistics_pro_growth.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/logistics_pro_growth.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/logistics_pro_growth.webp-wvc-sizes",
  alt: "Logistics Pro national search growth chart",
  badge: "",
  href: "/CaseStudiesPage"
}];
export default function Casestudyimpact() {
  const prefersReducedMotion = useReducedMotion();
  return <section data-section-id="22976" id="casestudyimpact" data-nav="light" className="bg-background text-foreground py-[clamp(6rem,12vw,11rem)]">
      <div className="mx-auto max-w-[1440px] px-[clamp(1.5rem,5vw,4.5rem)]">
        {}
        <div className="h-px w-full bg-border" />

        {}
        <div className="grid grid-cols-1 gap-x-6 gap-y-8 pt-[clamp(2rem,4vw,4rem)] lg:grid-cols-12">
          <div className="lg:col-span-3">
            <span className="font-sans text-[clamp(0.8125rem,0.85vw,0.9375rem)] font-medium uppercase tracking-[0.18em] text-muted-foreground">
              Proven results
            </span>
          </div>

          <div className="lg:col-span-9">
            <h2 className="font-serif font-normal text-foreground text-[clamp(1.75rem,2.75vw,2.375rem)] leading-[0.96] tracking-[-0.03em]">
              Verified{" "}
              <span className="relative inline-block italic">
                impact.
                <svg aria-hidden="true" viewBox="0 0 220 22" preserveAspectRatio="none" className="pointer-events-none absolute -bottom-2 left-0 h-[0.4em] w-full">
                  <path d="M4 14 Q 50 4, 110 10 T 216 8" stroke="var(--accent)" strokeWidth="8" strokeLinecap="round" fill="none" style={{
                  filter: "url(#roughen)"
                }} />
                  <path d="M6 16 Q 60 6, 120 12 T 214 10" stroke="var(--accent)" strokeWidth="4" strokeLinecap="round" fill="none" opacity="0.55" />
                </svg>
              </span>{" "}
              I&apos;ve delivered.
            </h2>

            <p className="mt-8 max-w-xl font-sans text-[clamp(1.0625rem,1.15vw,1.1875rem)] leading-[1.55] text-muted-foreground">
              Real-world SEO outcomes for businesses that value transparent, 
              data-driven growth over empty promises.
            </p>
          </div>
        </div>

        {}
        <div className="mt-[clamp(3rem,6vw,5rem)] grid grid-cols-1 gap-8 md:grid-cols-2">
          {projects.map((project, i) => <motion.div key={project.name} data-index={i} initial={false} whileHover={prefersReducedMotion ? undefined : {
          y: -6
        }} transition={{
          duration: 0.42,
          ease: [0.22, 1, 0.36, 1]
        }} className="group relative rounded-2xl bg-card p-[clamp(2rem,3vw,3rem)] transition-shadow duration-[420ms] hover:shadow-2xl">
              <Link to={project.href} aria-label={`View ${project.name} case study`} className="block">
                {}
                {project.badge ? <Badge className="absolute -top-3 right-6 z-10 rounded-lg bg-secondary px-3 py-1.5 font-sans text-[13px] font-semibold uppercase tracking-[0.14em] text-secondary-foreground shadow" style={{
              transform: "rotate(-7deg)"
            }}>
                    {project.badge}
                  </Badge> : null}

                {}
                <div className="relative overflow-hidden rounded-xl">
                  <div className="aspect-[4/5] w-full overflow-hidden">
                    <motion.img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" initial={false} whileHover={prefersReducedMotion ? undefined : {
                  scale: 1.04
                }} transition={{
                  duration: 0.6,
                  ease: "easeOut"
                }} />
                  </div>
                </div>

                {}
                <div className="mt-6 flex items-start justify-between gap-6">
                  <div className="flex flex-col gap-4">
                    <h3 className="font-serif text-[clamp(1.375rem,1.65vw,1.625rem)] font-normal leading-[1.05] tracking-[-0.02em] text-foreground">
                      {project.name}
                    </h3>

                    <span className="inline-flex w-fit items-center rounded-lg border border-border bg-transparent px-3.5 py-1.5 font-sans text-[clamp(0.9375rem,0.95vw,1rem)] font-medium tracking-[0.02em] text-foreground transition-colors duration-300 group-hover:border-primary">
                      {project.category}
                    </span>
                  </div>

                  <span aria-hidden="true" className="mt-2 inline-flex h-10 w-10 shrink-0 items-center justify-center text-primary">
                    <ArrowUpRight strokeWidth={1.25} className="h-5 w-5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                  </span>
                </div>
              </Link>
            </motion.div>)}
        </div>

        {}
        <div className="mt-[clamp(3rem,6vw,5rem)] flex justify-center">
          <Button asChild className="h-auto rounded-lg bg-primary px-8 py-4 font-sans text-[17px] font-medium text-primary-foreground shadow transition-all duration-300 hover:bg-primary/90 hover:tracking-[0.04em]">
            <Link to="/CaseStudiesPage">See all case studies</Link>
          </Button>
        </div>
      </div>
    </section>;
}